<template>
  <div>
    <div v-if="required" class="required-field"></div>
    <div class="mt-3">
      <v-menu v-model="dateMenu" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="formattedDate"
            v-on="on"
            v-bind="attrs"
            prepend-inner-icon="mdi-calendar-range"
            class="pl-0 mt-2"
            :class="{
              'required-field': required == true
            }"
            :value="formattedDate"
            :rules="rules"
            :required="required"
            @click:prepend="dateMenu = true"
            outlined
            dense
            clearable
          ></v-text-field>
        </template>

        <v-date-picker v-model="picker" @input="dateMenu = false" :value="formattedDate"></v-date-picker>
      </v-menu>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'
export default {
  name: 'resultDatepicker',
  data: () => ({
    dateMenu: false,
    dateMenuConfirmed: false,
    dateError: false,
    dateErrorMessage: '',
    dueDate: ''
  }),
  props: {
    date: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rules() {
      const rules = []
      const required = value => !!value || 'Field is required'
      if (this.required) {
        rules.push(required)
      }
      return rules
    },
    picker: {
      get() {
        if (this.date.length > 0) {
          return this.date || null
        } else if (this.value.length > 0) {
          return this.value
        } else {
          return this.date || null
        }
      },
      set(value) {
        this.$emit('update:date', value)
      }
    },
    formattedDate: {
      get() {
        return this.picker ? format(this.picker, 'DD-MM-YYYY') : ''
      },
      set(value) {
        return value
      }
    }
  },
  mounted() {
    if (this.date != '') {
      this.picker = this.date
    }
  }
}
</script>
